import { createFileRoute } from '@tanstack/react-router';
import { AktivitaetenPage } from '@pages/aktivitaeten';

/** Route für die Aktivitäten-Übersichtsseite (/aktivitaeten). */
export const Route = createFileRoute('/aktivitaeten/')({
  component: AktivitaetenPage,
});
